// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import React, { CSSProperties } from "react";
import { Button } from "@cloudscape-design/components";
import { useTranslation } from "react-i18next";
import { getPortalConfig, getPortalEndpoint } from "@utils/configurationUtils";

const EUCAuthButton = () => {
    const { t } = useTranslation();

    const onClick = () => {
        if (process.env.NODE_ENV === "development") {
            window.location.href = `https://${
                getPortalConfig().customerDomain
            }/authenticate?redirectOverride=${window.location.origin}/devRedirect`;
        } else {
            const portalEndpoint = getPortalEndpoint();
            window.location.href = `${portalEndpoint}/authenticate${window.location.search}`;
        }
    };

    const spanStyle: CSSProperties = {
        display: "inline-block",
        width: "220px",
        textAlign: "center",
    };

    return (
        <Button
            data-testid={"euc-sign-in-button"}
            onClick={onClick}
            variant="primary"
        >
            <span style={spanStyle} id="span-text">
                {t("login.button.label")}
            </span>
        </Button>
    );
};

export default EUCAuthButton;
